import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0dc328a8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "新增业务", -1);
});

var _hoisted_2 = {
  class: "custom-label"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "required-star"
  }, "*", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "关联SRE业务树", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_6 = {
  class: "custom-item"
};
var _hoisted_7 = {
  class: "dialog-footer"
};
import { ref, reactive, computed, watchEffect } from 'vue';
import userMemberSearch from './userMemberSearch.vue';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  props: {
    detailData: {
      type: Object,
      defaultValue: {}
    },
    visible: Boolean,
    showSRETree: Boolean,
    corporationId: String
  },
  emits: ['closeDialog', 'updateList'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var confirmDisabled = ref(false);
    var validateFormData = reactive({
      busiCode: '',
      busiName: '',
      userList: []
    });
    var formRef = ref();
    var sreValue = ref([]);
    var sreTreeRef = ref(null);
    var sreIdPathValue = computed(function () {
      if (Array.isArray(sreValue.value) && sreValue.value.length > 0) {
        return "/".concat(sreValue.value.join('/'));
      }

      return '无';
    });
    var cascaderProps = reactive({
      lazy: true,
      lazyLoad: function lazyLoad(node, resolve) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _data$data;

          var value, pathLabels, fullPath, data, result, nodes;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  value = node.value, pathLabels = node.pathLabels;
                  fullPath = '/';

                  if (value) {
                    fullPath = "/".concat(pathLabels === null || pathLabels === void 0 ? void 0 : pathLabels.join('/'), "/");
                  }

                  _context.next = 5;
                  return CompanyService.getChildNodeList({
                    fullPath: fullPath,
                    productOnly: true
                  });

                case 5:
                  data = _context.sent;

                  if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                    result = data.data.result;
                    nodes = result.map(function (item) {
                      return {
                        value: item.id,
                        label: item.name,
                        leaf: item.leaf
                      };
                    });
                    resolve(nodes);
                  }

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    });

    var cascaderChange = function cascaderChange(val) {
      console.log('---------cascaderChange', val);
    };

    var validateBusiCode = function validateBusiCode(rule, value, callback) {
      var pattern1 = new RegExp('^[0-9a-zA-Z_]{1,}$');

      if (value && !pattern1.test(value)) {
        confirmDisabled.value = true;
        callback(new Error('不可出现英文字母+数字+下划线外的其他字符，且英文标识不可重复'));
      } else {
        confirmDisabled.value = false;
        callback();
      }
    };

    var validateBusiName = function validateBusiName(rule, value, callback) {
      var pattern1 = new RegExp("^[0-9\u4E00-\u9FA5a-zA-Z_]{1,}$");

      if (value && !pattern1.test(value)) {
        confirmDisabled.value = true;
        callback(new Error('不可出现中英文字母+数字+下划线外的其他字符'));
      } else {
        confirmDisabled.value = false;
        callback();
      }
    };

    var validateUserList = function validateUserList(rule, value, callback) {
      var pattern1 = new RegExp('[A-Za-z]+');
      var pattern2 = new RegExp("[\u4E00-\u9FA5]+");

      if (value && !pattern1.test(value) && !pattern2.test(value)) {
        confirmDisabled.value = true;
        callback(new Error('不可出现中英文字符外的其他字符'));
      } else {
        confirmDisabled.value = false;
        callback();
      }
    };

    var rules = reactive({
      busiCode: [{
        validator: validateBusiCode,
        trigger: ['blur', 'change']
      }],
      busiName: [{
        validator: validateBusiName,
        trigger: ['blur', 'change']
      }],
      userList: [{
        validator: validateUserList,
        trigger: ['blur', 'change']
      }]
    });
    var dialogVisible = ref(props.visible);
    watchEffect(function () {
      dialogVisible.value = props.visible;

      if (props.visible) {}
    });

    var handleDialogClose = function handleDialogClose() {
      emits('closeDialog');
    };

    var queryFullTree = function queryFullTree() {
      window.open('https://sre.woa.com/#/cost/resourceList', '_blank');
    };

    var createHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(formEl) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (formEl) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                formEl.validate( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    var _sreTreeRef$value, _sreTreeRef$value$get, _sreTreeRef$value$get2, _validateFormData$use, _data$data2, namePathList, data, _data$data3;

                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 10;
                              break;
                            }

                            confirmDisabled.value = false;
                            console.log('submit!');
                            namePathList = ((_sreTreeRef$value = sreTreeRef.value) === null || _sreTreeRef$value === void 0 ? void 0 : (_sreTreeRef$value$get = _sreTreeRef$value.getCheckedNodes()) === null || _sreTreeRef$value$get === void 0 ? void 0 : (_sreTreeRef$value$get2 = _sreTreeRef$value$get[0]) === null || _sreTreeRef$value$get2 === void 0 ? void 0 : _sreTreeRef$value$get2.pathLabels) || [];
                            _context2.next = 6;
                            return CompanyService.createBusinessInfo({
                              corporationId: props.corporationId,
                              adminUserIdList: (_validateFormData$use = validateFormData.userList) === null || _validateFormData$use === void 0 ? void 0 : _validateFormData$use.map(function (item) {
                                return item.user_id;
                              }),
                              busiCode: validateFormData.busiCode,
                              busiName: validateFormData.busiName,
                              sreBusiIdPath: props.showSRETree ? "".concat(sreIdPathValue.value, "/") : null,
                              sreBusiNamePath: props.showSRETree ? "/".concat(namePathList.join('/')) : null
                            });

                          case 6:
                            data = _context2.sent;

                            if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                              emits('updateList');
                              handleDialogClose();
                            } else {
                              if ((_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.msg) {
                                ElMessage.error(data.data.msg);
                              }
                            }

                            _context2.next = 13;
                            break;

                          case 10:
                            confirmDisabled.value = true;
                            console.log('error submit!');
                            return _context2.abrupt("return", false);

                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function createHandler(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var updateUserList = function updateUserList(list) {
      validateFormData.userList = list;
    };

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_cascader = _resolveComponent("el-cascader");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return dialogVisible.value = $event;
        }),
        width: 736,
        "show-close": false,
        "before-close": handleDialogClose,
        "custom-class": "custom-modal add-busi-modal"
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "title"
          }, [_hoisted_1, _createElementVNode("i", {
            class: "iconfont iconclose-line",
            onClick: handleDialogClose
          })])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
            class: "btn-item cancel-btn",
            onClick: handleDialogClose
          }, "取消"), _createElementVNode("div", {
            class: _normalizeClass(['btn-item confirm-btn', {
              'btn-item-disabled': confirmDisabled.value
            }]),
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return createHandler(formRef.value);
            })
          }, " 确定 ", 2)])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "label-width": "139px",
            model: _unref(validateFormData),
            rules: _unref(rules),
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "业务英文标识",
                prop: "busiCode",
                rules: [{
                  required: true,
                  message: '业务英文标识不能为空',
                  trigger: ['blur']
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(validateFormData).busiCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(validateFormData).busiCode = $event;
                    }),
                    maxlength: "20",
                    placeholder: "支持输入英文字母+数字+下划线，最长20字符，且英文标识不可编辑"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "业务名称",
                prop: "busiName",
                rules: [{
                  required: true,
                  message: '业务名称不能为空',
                  trigger: ['blur']
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(validateFormData).busiName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(validateFormData).busiName = $event;
                    }),
                    maxlength: "20",
                    placeholder: "支持输入中英文字符+数字+下划线，最长20字符"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "业务管理员",
                prop: "userList",
                rules: [{
                  required: true,
                  message: '业务管理员不能为空'
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(userMemberSearch, {
                    userSelectedList: _unref(validateFormData).userList,
                    corporationId: __props.corporationId,
                    onUpdateUserList: updateUserList
                  }, null, 8, ["userSelectedList", "corporationId"])];
                }),
                _: 1
              }), __props.showSRETree ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                style: {
                  "margin-bottom": "0"
                }
              }, {
                label: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: "一个SRE业务仅可被一个灯塔业务关联",
                    placement: "top"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5];
                    }),
                    _: 1
                  })])];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_cascader, {
                    modelValue: sreValue.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return sreValue.value = $event;
                    }),
                    ref_key: "sreTreeRef",
                    ref: sreTreeRef,
                    props: _unref(cascaderProps),
                    filterable: "",
                    placeholder: "请选择关联SRE业务树",
                    style: {
                      "width": "100%"
                    },
                    onChange: cascaderChange
                  }, null, 8, ["modelValue", "props"]), _createElementVNode("span", {
                    class: "text",
                    onClick: queryFullTree
                  }, "查询完整业务树")])];
                }),
                _: 1
              })) : _createCommentVNode("", true), __props.showSRETree ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "关联SRE业务树ID",
                style: {
                  "margin-bottom": "0"
                }
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(sreIdPathValue)), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});